export default "__VITE_ASSET__GDkVPQAp__"